import { Fieldset, Legend } from '@paytrace/pt-skel/Component'
import ColorGrid from '../../Component/ColorGrid'
import DownloadButtonIcon from '../../Component/DownloadButtonIcon'
import React from 'react'

const DisplayLayout = ({
  children,
  style,
  setDownloadClicked,
  isDownloadClicked,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
  setDownloadClicked?: (value: boolean) => void;
  isDownloadClicked?: boolean;
}) => {
  return (
    <Fieldset>
      <div
        className="gray-bg"
        style={{
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'space-between',
          borderBottom: '1px solid #ccc',
        }}
      >
        <div
          style={{
            flex: '0 0 auto',
            borderRight: '1px solid #ccc',
            height: 'auto',
            paddingTop: '5px',
          }}
        >
          <ColorGrid />
        </div>
        <div style={{ flex: '1', textAlign: 'left' }}>
          <Legend title={'Search Results'} />
        </div>
        <div style={{ flex: '0 0 auto', textAlign: 'right' }}>
          <button
            disabled={!isDownloadClicked}
            onClick={async () => {
              setDownloadClicked && setDownloadClicked(true)
            }}
            className="download-results"
            style={{
              textShadow: 'none',
              padding: '4px 16px',
              color: '#333',
              backgroundColor: '#fff',
            }}
          >
            <DownloadButtonIcon /> Download Results
          </button>
        </div>
      </div>
      <div style={{ ...style, marginLeft: 'auto' }}>{children}</div>
    </Fieldset>
  )
}

export default DisplayLayout
